
import { Component, Vue } from 'vue-property-decorator'
import { getRecruit } from '@/api/recruit'
import { IJobSocialData } from '@/api/types'
import { UserModule } from '@/store/modules/user'
import Pagination from '@/components/Pagination/index.vue'

@Component({
  name: 'Table',
  components: {
    Pagination
  },
  filters: {
    statusFilter: (status: string) => {
      const statusMap: { [key: string]: string } = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    },
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toISOString()
    }
  }
})
export default class extends Vue {
  private list: IJobSocialData[] = []
  private listLoading = true
  private total = 0
  private jobOptions = ['iOS开发工程师', 'Android开发工程师', 'Web开发工程师', '软件开发工程师-C/C++方向', '软件开发工程师-Golang方向', '软件开发工程师-云原生方向', '边缘计算开发工程师', '分布式系统开发工程师', '搜索算法工程师', 'AI算法工程师', 'AI系统工程师', '多媒体开发工程师', '存储开发工程师', '安全开发工程师', '网络通信开发工程师', '无线通信开发工程师', 'Linux系统开发工程师', 'Linux驱动开发工程师', '运维开发工程师', '软件测试工程师', '产品经理-软件方向', '平面设计师', '交互设计师', '产品经理-硬件方向', '工业设计师', '硬件工程师', '电路设计工程师', '外观工艺工程师', '结构工程师', '硬件测试工程师']
  private isSocialOptions = [{ id: 0, value: '校园招聘' }, { id: 1, value: '社会招聘' }]
  private listQuery = {
    page: 1,
    limit: 20
  }

  handleFilter() {
    console.log('search')
    this.listQuery.page = 1
    this.getList()
  }

  downloadRecruit(row: any) {
    console.log('download', row)
    window.location.href = process.env.VUE_APP_BASE_API + 'download/' + row.id + '?X-Access-Token=' + UserModule.token
  }

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    const { data } = await getRecruit(this.listQuery)
    this.list = data.items
    this.total = data.total
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }
}
